import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/reglement-inscription`;

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

/// GET
export const getAllReglementInscription = async () => {
  try {
    const response = await axios.get(`${apiUrl}/allreglementsinscriptions`, {
      headers: getAuthHeaders(),
    });

    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors du chargement des règlements d'inscription:",
      error
    );
    return [];
  }
};

export const getAllReglementInscriptionBySaison = async (saison) => {
  try {
    const response = await axios.get(
      `${apiUrl}/allreglementsinscriptions/${saison}`,
      {
        headers: getAuthHeaders(),
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors du chargement des règlements d'inscription:",
      error
    );
    return [];
  }
};

export const getReglementInscriptionById = async (id) => {
  try {
    const response = await axios.get(`${apiUrl}/reglement-inscription/${id}`, {
      headers: getAuthHeaders(),
    });

    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors du chargement du règlement d'inscription:",
      error
    );
    return null;
  }
};

export const getReglementInscriptionByIdAndSaison = async (
  adherentId,
  saison
) => {
  try {
    const response = await axios.get(`${apiUrl}/${adherentId}/${saison}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response?.status === 404) {
      return null;
    }

    console.error(
      "Erreur lors du chargement du règlement d'inscription:",
      error
    );

    return null;
  }
};

export const getStatutReglementsCount = async () => {
  try {
    const response = await axios.get(`${apiUrl}/statut-reglements-count`, {
      headers: getAuthHeaders(),
    });

    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getStatutReglementsCountBySaison = async (saison) => {
  try {
    const response = await axios.get(
      `${apiUrl}/statut-reglements-count-saison/${saison}`,
      {
        headers: getAuthHeaders(),
      }
    );

    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getTypeReglementsCount = async () => {
  try {
    const response = await axios.get(`${apiUrl}/repartition-types-reglements`, {
      headers: getAuthHeaders(),
    });

    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getTypeReglementsCountBySaison = async (saison) => {
  try {
    const response = await axios.get(
      `${apiUrl}/repartition-types-reglements-saison/${saison}`,
      {
        headers: getAuthHeaders(),
      }
    );

    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

/// POST
export const createReglementInscription = async (newReglement) => {
  try {
    const response = await axios.post(
      `${apiUrl}/add-reglement-inscription`,
      newReglement,
      {
        headers: getAuthHeaders(),
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erreur lors de la création du règlement", error);
    return null;
  }
};

/// PUT
export const updateReglementInscription = async (reglement) => {
  const { id, ...data } = reglement;

  try {
    const response = await axios.put(
      `${apiUrl}/update-reglement-inscription/${id}`,
      data,
      {
        headers: getAuthHeaders(),
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour du règlement", error);
    return null;
  }
};

/// DELETE
export const deleteReglementInscription = async (id) => {
  try {
    const response = await axios.delete(
      `${apiUrl}/delete-reglement-inscription/${id}`,
      {
        headers: getAuthHeaders(),
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression du règlement", error);
    return null;
  }
};